module.exports = __webpack_public_path__ + "aiohttp.b7cc36.svg";